const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export const formatContentDate = (value, options = {}) => {
  if (!value) return '';

  const isDateOnly = DATE_ONLY_PATTERN.test(value);
  const date = new Date(isDateOnly ? `${value}T00:00:00Z` : value);

  if (Number.isNaN(date.getTime())) return '';

  return date.toLocaleDateString('en-US', {
    ...options,
    ...(isDateOnly ? { timeZone: 'UTC' } : {}),
  });
};
